import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { ComponentContainer } from '@styles/layout';
import { GenericComponent } from '@model/content';

const Title = styled.h1(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h2 as any),
  marginBottom: 10
}));

export const TitleContainer = ({ value }: GenericComponent) => {
  return (
    <ComponentContainer>
      <Title>{value}</Title>
    </ComponentContainer>
  );
};
